import { userFullName, urlRegx, openApp } from 'src/helpers';

import Model from 'src/storage/messageList';

import appModel from 'src/model';

class Messages extends Model {
  id = 'messages';
  persistent = false;
  listPersistent = false;
  apiConfig = {
    list: {
      url: 'message/list',
      validation: {
        lastNumber: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    refresh: {
      url: 'message/refresh',
      validation: {
        limit: 'limit'
      },
      cancellable: true,
      event: 'messageRefresh'
    },
    search: {
      url: 'message/search',
      validation: {
        query: 'string',
        limit: 'limit'
      },
      cancellable: true
    },
    clear: {
      url: 'message/clear',
      validation: {
        partnerId: 'userId'
      },
      cancellable: true
    },
    create: {
      url: 'contact/sendMessage',
      validation: {
        partnerId: 'number',
        text: 'string'
        // images: 'array'
      },
      cancellable: false
    },
    edit: {
      url: 'message/edit',
      validation: {
        messageId: 'string',
        text: 'string'
      },
      cancellable: false
    },
    removeMessage: {
      url: 'message/remove',
      validation: {
        messageId: 'string',
        forBoth: 'boolean'
      },
      cancellable: false
    },
    upload: {
      url: 'contact/upload',
      cancellable: true,
      validation: {}
    },
    block: {
      url: 'contact/blocked/createId',
      validation: {
        blockedId: 'userId'
      },
      cancellable: true
    },
    unblock: {
      url: 'contact/blocked/remove',
      validation: {
        blockedId: 'userId'
      },
      cancellable: true
    },
    removeContact: {
      url: 'contact/remove',
      validation: {
        partnerId: 'userId'
      },
      cancellable: false
    },
    preview: {
      url: 'url/preview',
      validation: {
        url: 'url'
      },
      cancellable: true
    },
    markRead: {
      url: 'contact/markRead',
      validation: {
        partnerId: 'userId',
        lastNumber: 'number'
      },
      cancellable: false
    },
    typing: {
      url: 'contact/typing',
      validation: {
        partnerId: 'userId'
      },
      cancellable: true
    },
    findById: {
      url: 'doctor/detail',
      validation: {
        id: 'number'
      },
      cancellable: true
    },
    getTicket: {
      url: 'contact/getTicket',
      cancellable: true,
      validation: {
        partnerId: 'userId',
        hospitalId: 'any'
      }
    },
    buyTicket: {
      url: 'contact/buyTicket',
      cancellable: true,
      validation: {
        partnerId: 'userId'
      }
    },
    createTicketPaymentIntent: {
      url: 'contact/createTicketPaymentIntent',
      cancellable: true,
      validation: {
        partnerId: 'userId'
      }
    },
    confirmPaymentIntent: {
      url: 'contact/confirmPaymentIntent',
      cancellable: true,
      validation: {
        paymentIntentId: 'string'
      }
    }
  };
  defaultState = () => ({
    stream: null,
    isActive: true,
    contact: null,
    ticket: null,
    search: ''
  });
  listLimit = 30;
  _events = {
    openContact: 'onOpenContact',
    'foxsocket:message:msg': 'onMessage',
    'foxsocket:message:msg_update': 'onMessageUpdateWS',
    'appState:foreground': 'onAppStateChange',
    'foxsocket:message:contact_blocked_create': 'contactBlockCreatedWS',
    'foxsocket:message:contact_blocked_remove': 'contactBlockRemovedWS',
    'foxsocket:message:contact_update': 'onUpdateContactWS',
    'foxsocket:message:bought_ticket': 'onBoughtTicketWS',
    'foxsocket:message:sold_ticket': 'onBoughtTicketWS',
    'foxsocket:message:ticket_update': 'onTicketUpdateWS',
    replyOrForwardedMsg: 'onReplyOrForwardedMsg',
    messageRefresh: 'onRefresh'
  };

  sortBy = {
    key: 'counter',
    desc: true
  };

  typingTimeout = 2000;

  onOpenContact = ({ contact }) => {
    let oldPartnerId = this.state.partnerId;
    let newPartnerId = contact.partnerId;
    this.setStateSilent({ current: newPartnerId + ':recent', partnerId: newPartnerId, contact });

    if (oldPartnerId !== newPartnerId) {
      this.setStateSilent({ ticket: null, appointment: null, charge: null });
      this.refresh(newPartnerId + ':recent');
      this.getTicket(contact);
    }
  };

  getTicket = (contact, cb) => {
    let partnerId = contact.partnerId || contact.id;
    this.api('getTicket', { partnerId }, (err, res, success) => {
      if (success && this.state.partnerId == partnerId) {
        let { ticket, appointment, charge, isFreeChat } = res;
        this.setState({ ticket, appointment, charge, isFreeChat });
        clearInterval(this.getTicketInterval);
        this.getTicketInterval = setInterval(() => {
          this.refreshTicket(contact);
        }, 1000 * 60);
        cb && cb();
      }
    });
  };

  refreshTicket = (contact) => {
    this.getTicket(contact);
  };

  createTicketPaymentIntent = (cb) => {
    this.setStateSilent({ ticketPaymentIntent: null, clientSecret: null });
    return this.api(
      'createTicketPaymentIntent',
      { partnerId: this.state.partnerId },
      (err, res, success) => {
        if (success) {
          this.setStateSilent({ ticketPaymentIntent: res, clientSecret: res.clientSecret });
        }
        cb && cb(err, res, success);
      }
    );
  };

  confirmTicketPaymentIntent = (paymentIntent, cb) => {
    return this.api(
      'confirmPaymentIntent',
      { paymentIntentId: paymentIntent.id },
      (err, res, success) => {
        this.emit('payment_result', { paymentIntent, err, data: res, success });
        if (success) {
          this.setStateSilent({ buyTicketResponse: res });
          if (res && res.chargeResult?.success && res.ticket) {
            let { ticket } = res;
            if (ticket.doctorId == this.state.partnerId) {
              this.setState({ ticket });
            }
            openApp({ action: 'chat', contactId: this.state.partnerId });
          }
        }
        typeof cb == 'function' && cb(err, res, success);
      }
    );
  };

  buyTicket = (cardId, cb) => {
    if (typeof cardId === 'function') cb = cardId;
    let partnerId = this.state.partnerId;
    this.api('buyTicket', { partnerId, cardId }, (err, res, success) => {
      if (success) {
        this.setStateSilent({ buyTicketResponse: res });
        if (res && res.chargeResult?.success && res.ticket) {
          this.emit('payment_result', { err, data: res, success });
          let { ticket } = res;
          if (ticket.doctorId == this.state.partnerId) {
            this.setState({ ticket });
          }
          openApp({ action: 'chat', contactId: this.state.partnerId });
        }
      }
      typeof cb == 'function' && cb(err, res, success);
    });
  };

  onBoughtTicketWS = ({ data }) => {
    let ticket = data && data.ticket;
    if (!ticket) return;
    if (ticket.doctorId == this.state.partnerId || ticket.patientId == this.state.partnerId) {
      this.setState({ ticket });
    }
  };

  onTicketUpdateWS = ({ data }) => {
    this.log('onTicketUpdateWS');
    let ticket = data && data.ticket;
    if (!ticket) return;
    if (ticket.doctorId == this.state.partnerId || ticket.patientId == this.state.partnerId) {
      this.setState({ ticket });
      this.log('onTicketUpdateWS done');
    }
  };

  isChatAvailable = () => {
    if (!this.isLogged) return false;
    let { contact, ticket, charge } = this.state;
    if (!contact.isDoctor || !charge) return true;
    if ((ticket && ticket.doctorId == this.userId) || !charge.paid) return true;
    if (!ticket) return false;
    ticket.available =
      Date.now() >= ticket.startDate &&
      Date.now() <= ticket.endDate &&
      ticket.messages < ticket.maxMessages;
    return ticket.available;
  };

  contactBlockCreatedWS = ({ data }) => this.updateContactBlock(data.blockedId, true);
  contactBlockRemovedWS = ({ data }) => this.updateContactBlock(data.blockedId, false);
  updateContactBlock = (partnerId, blocked) => {
    if (partnerId === this.state.partnerId) {
      let contact = this.state.contact;
      contact.blocked = blocked;
      this.setState({ contact });
    }
  };

  selectedMessages() {
    return this.getCurrent(this.current).selectedMessages || [];
  }

  messageType() {
    let current = this.getCurrent(this.current);

    return current.messageType;
  }

  markRead = (partnerId, lastNumber) => {
    this.api('markRead', { partnerId, lastNumber });
  };

  listParams(loadMore) {
    const partnerId = this.state.partnerId;
    if (!partnerId) return null;

    let req = {
      partnerId,
      limit: this.listLimit
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.skip = 0;
      req.query = query;
    } else {
      req.lastNumber = 0;
    }
    if (loadMore) {
      if (query) {
        let skip = this.items().length;
        if (skip < this.listLimit) return null;
        req.skip = skip;
      } else {
        let clearCount = (this.state.contact && this.state.contact.clearCount) || 0;
        var lastNumber = 0;
        let items = this.items().filter((item) => item.state != 'sending');
        if (items.length > 0) {
          let counter = items[items.length - 1].counter;
          if (counter > 0) lastNumber = counter;
        }
        this.log('loadMore', { clearCount, lastNumber });
        if (lastNumber <= 1 || lastNumber <= clearCount) return null;
        req.lastNumber = lastNumber;
      }
    }
    return req;
  }

  profile = () => {
    let contact = this.state.contact || {};
    return {
      id: contact.partnerId,
      name: contact.partnerName || userFullName(contact, contact?.isDoctor),
      firstName: contact.firstName || '',
      lastName: contact.lastName || '',
      avatar: contact.partnerAvatar || contact.avatar || 0,
      gender: contact.partnerGender,
      avatarUrls: contact.partnerAvatarUrls,
      role: contact.partnerRole || 'User',
      lastRead: contact.lastRead,
      partnerLastRead: contact.partnerLastRead,
      partnerTyping: contact.partnerTyping,
      isPartnerTyping:
        Date.now() - contact.partnerTyping - appModel.getTimeShift() < this.typingTimeout
    };
  };

  onAppStateChange = (value) => {
    this.setState({ isActive: value }, null, true);
  };

  makeConvId(user1, user2) {
    if (user1 > user2) {
      return user1 + '.' + user2;
    } else {
      return user2 + '.' + user1;
    }
  }

  getContact = () => {
    return this.state.contact || {};
  };

  isBlocked = () => {
    return this.getContact().blocked;
  };

  block = (cb) => {
    let blockedId = this.state.partnerId;
    let req = { blockedId };
    this.state.contact.blocked = true;
    this.api('block', req, (err, res, success) => {
      if (!success) {
        this.state.contact.blocked = false;
      }
      cb && cb(err, res, success);
    });
  };

  unblock = (cb) => {
    let blockedId = this.state.partnerId;
    let req = { blockedId };
    this.state.contact.blocked = false;
    this.api('unblock', req, (err, res, success) => {
      if (!success) {
        this.state.contact.blocked = true;
      }
      cb && cb(err, res, success);
    });
  };

  sendMessage = () => {
    if (openApp({ action: 'chat', contactId: this.state.partnerId }))
      return;
    let { messageType } = this.getCurrent();
    if (messageType === 'edit') {
      this.editMessage();
    } else {
      this.createMessage();
    }
  };

  editMessage = () => {
    let { originalMessage } = this.getCurrent();
    let { id, textOrigin, edited: originalEdited } = originalMessage;
    let previewUrl = this.listGet('previewUrl');
    let preview = this.listGet('preview');
    let partnerId = this.state.partnerId;
    let text = this.listInput();
    this.onMessageUpdate({
      id,
      edited: Date.now(),
      text,
      partnerId,
      preview,
      previewUrl: preview ? previewUrl : null
    });
    this.clearSelectedMessage();
    this.api(
      'edit',
      { messageId: id, text, preview, previewUrl: preview ? previewUrl : null },
      (err, res, success) => {
        if (!success) {
          this.onMessageUpdate({
            id,
            edited: originalEdited,
            text: textOrigin,
            preview,
            previewUrl: preview ? previewUrl : null,
            partnerId
          });
        }
      }
    );
  };

  createMessage = () => {
    let userId = this.userId;
    let { ticket, partnerId, isFreeChat } = this.state;
    if (!this.isChatAvailable()) return this.emit('TICKET_UNAVAILABLE');
    if (
      ticket &&
      ticket.available &&
      partnerId == ticket.doctorId &&
      this.userId == ticket.patientId &&
      !isFreeChat
    ) {
      ticket.messages += 1;
      this.setStateSilent({ ticket });
    }

    let text = this.listInput();
    let files = this.listGet('files') || [];
    let previewUrl = this.listGet('previewUrl');
    let preview = this.listGet('preview');
    let selfDestruct = this.listGet('selfDestruct');
    if (!text && files.length === 0) return;
    let convId = this.makeConvId(userId, partnerId);

    let items = this.items(partnerId + ':recent');
    let prevItem =
      items.length > 0 ? items[items.length - 1] : { id: 0, counter: 0, date: Date.now() - 1 };
    let counter = prevItem.counter + 0.001;
    let tempId = convId + '_' + counter + '_' + Date.now() + '_' + Math.random();
    let msg = {
      id: tempId,
      tempId,
      counter,
      text,
      own: true,
      from: userId,
      to: partnerId,
      state: 'sending',
      preview,
      previewUrl: preview ? previewUrl : null,
      media: files,
      files,
      date: Date.now() > prevItem.date ? Date.now() : prevItem.date + 1
    };
    items.unshift(this.mapItem(msg, -1, items));
    this.cancelApi('preview');
    this.setListState({
      items,
      input: '',
      previewUrl: null,
      preview: null,
      files: []
    });
    this.emit('newMessage', msg);

    let req = {
      tempId,
      text,
      partnerId,
      files,
      preview,
      data: { selfDestruct },
      previewUrl: preview ? previewUrl : null
    };

    this._apiCreate(partnerId, tempId, req);
  };

  clearChat = (cb) => {
    let partnerId = this.state.partnerId;
    let lastMessage = this.items()[0];
    let clearCount = lastMessage ? lastMessage.counter : 0;
    this.log('clearChat current clearCount:', clearCount);
    this.setState(
      {
        contact: {
          ...this.state.contact,
          clearCount
        }
      },
      null,
      true
    );
    this.setListStateSilent({ items: [], hasMore: false }, this.state.partnerId + ':recent');
    this.setListStateSilent({ items: [], hasMore: false }, this.state.partnerId + ':search');
    this.api('clear', { partnerId }, cb);
    this.emit('updateContact', { partnerId, data: { clearCount } });
  };

  onUpdateContactWS = ({ data }) => {
    if (this.state.partnerId === data.partnerId) {
      let contact = this.state.contact;
      let refreshTicket = false;
      if (data.key === 'status') {
        contact.status = data.value;
        refreshTicket = true;
      }
      if (data.key === 'freeChatEnabled') {
        contact.freeChatEnabled = data.value;
        refreshTicket = true;
      }
      Object.keys(data).map((key) => {
        if (key !== 'key' && key !== 'value') {
          contact[key] = data[key];

          if (key === 'partnerAvatar' || key === 'partnerId' || key === 'partnerGender') {
            contact.partnerAvatarUrls = this.makeUserAvatar(
              { id: contact.partnerId, gender: contact.partnerGender },
              contact.partnerAvatar,
              this.imageSizes.user
            );
          }
          if (key === 'partnerTyping') {
            clearTimeout(this.partnerTypingTimeout);
            this.partnerTypingTimeout = setTimeout(this.trigger, this.typingTimeout + 100);
          }
        }
      });
      if (refreshTicket) this.refreshTicket(contact);
      if (data.removed) {
        this.setState(this.defaultState());
      } else {
        this.setStateSilent({ contact });
        if (data.partnerLastRead) this.remapItems();
        this.trigger();
      }
    }
  };

  onSelectMessage = (message) => {
    const selectedMessages = this.selectedMessages();

    const index = selectedMessages.findIndex((item) => item.id === message.id);

    if (index > -1) {
      selectedMessages.splice(index, 1);
    } else {
      selectedMessages.push(message);
    }

    this.setListState({ selectedMessages, messageType: null });
  };

  clearSelectedMessage = () => {
    this.cancelApi('preview');
    this.setListState({
      input: '',
      previewUrl: null,
      preview: null,
      files: [],
      selectedMessages: [],
      originalMessage: null,
      messageType: null
    });
  };

  onEditMessage = (message) => {
    if (!message) message = this.selectedMessages()[0];

    this.setListState({
      input: message.textOrigin,
      previewUrl: message.previewUrl,
      preview: message.preview,
      files: [],
      messageType: 'edit',
      originalMessage: message,
      selectedMessages: []
    });
  };

  removeMessage = (id, forBoth, cb, skipApi) => {
    this.clearSelectedMessage();
    let partnerId = this.state.partnerId;
    this.onMessageUpdate({
      id,
      partnerId,
      removed: forBoth ? [this.userId, this.state.partnerId] : [this.userId]
    });
    if (skipApi) return;
    this.api('removeMessage', { messageId: id, forBoth }, (err, res, success) => {
      if (!success)
        this.onMessageUpdate({
          id,
          partnerId,
          removed: false
        });
      cb && cb(err, res, success);
    });
  };

  removeContact = () => {
    let partnerId = this.state.partnerId;
    this.api('removeContact', { partnerId });
    this.setState(this.defaultState());
  };

  clearImageInput = () => {
    this.setListState({
      files: []
    });
  };

  onChangeInput = (key, value, append) => {
    this.listHandleChange(key, value, append);
    this.updateTyping();

    const newUrl = this.getUrl(key);
    const previewUrl = this.listGet('previewUrl');

    if (newUrl === previewUrl) {
      return;
    }

    this.listHandleChange('previewUrl', newUrl);
    this.listHandleChange('preview', null);
    this.listHandleChange('previewing', !!newUrl);

    clearTimeout(this.changeUrlTimeout);
    this.cancelApi('preview');
    this.changeUrlTimeout = setTimeout(() => this.preview(newUrl), 300);
  };

  updateTyping = () => {
    let typing = this.listGet('typing');
    let now = Date.now();
    if (now - typing > 1000) {
      this.setListStateSilent({ typing: now });
      this.api('typing', { partnerId: this.state.partnerId });
    }
  };

  getUrl = (value = '') => {
    const urls = value.match(urlRegx);

    if (urls && urls.length) {
      return urls[0];
    }

    return '';
  };

  preview = async (url) => {
    const isValidApi = this.isInvalidApi('preview', { url });
    if (!isValidApi) return;
    this.api('preview', { url }, (err, res, success) => {
      const message = this.listGet('input') || '';
      this.listHandleChange('previewing', false);
      if (success && message.includes(url)) {
        this.listHandleChange('preview', {
          title: res.title || '',
          description: res.description || '',
          image: res.image || '',
          link: res.link || ''
        });
      }
    });
  };

  onCancelPreview = () => {
    this.setListState({
      preview: null,
      previewing: false
    });
  };

  onRecord = (record, cancel) => {
    this.log('onRecord', record);
    if (!record || cancel) return;
    this.setListStateSilent({ recording: record.recording });
    this.setListState({
      files: [record],
      updated: Date.now()
    });
    this.createMessage && this.createMessage();
  };

  _onRefresh = () => {};
  onRefresh = () => {
    this._onRefresh();
  };

  onReplyOrForwardedMsg = (data) => {
    let partnerId = data.partnerId;
    let newPartnerId = data.partnerId;
    let oldPartnerId = this.state.partnerId;
    let contact = this.state.contact;
    const cb = () => {
      contact.partnerId = contact.id;
      this.setStateSilent({ current: newPartnerId + ':recent', partnerId: newPartnerId, contact });
      if (oldPartnerId !== newPartnerId) {
        this._onRefresh = () => {
          this.sendReplyOrForwardedMsg({ partnerId: newPartnerId, ...data });
          this._onRefresh = () => {};
        };
        this.refresh(newPartnerId + ':recent');
      } else {
        this.sendReplyOrForwardedMsg({ partnerId: newPartnerId, ...data });
      }
    };
    if (contact) {
      cb();
    } else {
      this.api('findById', { id: partnerId }, (err, res, success) => {
        if (success) {
          if (!res.partnerId) res.partnerId = partnerId;
          contact = res;
          cb();
        }
      });
    }
  };
  sendReplyOrForwardedMsg = ({ partnerId, originalMsg, type }) => {
    let userId = this.userId;
    let convId = this.makeConvId(userId, partnerId);

    let items = this.items(partnerId + ':recent');
    let prevItem =
      items.length > 0 ? items[items.length - 1] : { id: 0, counter: 0, date: Date.now() - 1 };
    let counter = prevItem.counter + 0.001;
    let tempId = convId + '_' + counter + '_' + Date.now() + '_' + Math.random();
    let msg = {
      ...originalMsg,
      id: tempId,
      tempId,
      counter,
      own: true,
      from: userId,
      to: partnerId,
      state: 'sending',
      msgType: originalMsg.msgType,
      date: Date.now() > prevItem.date ? Date.now() : prevItem.date + 1
    };
    msg.data.originalMsgType = originalMsg.msgType;

    if (type === 'reply') msg.replyTo = originalMsg.id;
    if (type === 'forward') msg.forwarded = originalMsg.id;

    items.unshift(this.mapItem(msg, -1, items));
    this.setListState({
      items,
      input: '',
      previewUrl: null,
      preview: null,
      files: []
    });
    this.emit('newMessage', msg);
    this.emit('changeMessageTab', { id: 'chat' });

    let req = {
      tempId,
      partnerId,
      replyTo: msg.replyTo,
      forwarded: msg.forwarded,
      text: msg.text,
      media: msg.media,
      links: msg.links,
      preview: msg.preview,
      previewUrl: msg.previewUrl,
      msgType: msg.msgType,
      data: msg.data
    };

    this._apiCreate(partnerId, tempId, req);
  };

  _apiCreate(partnerId, tempId, req) {
    this.api('create', req, (err, res, success) => {
      if (err == 'TICKET_UNAVAILABLE') {
        this.setState({ ticket: null });
        this.getTicket(this.state.contact);
        this.emit('TICKET_UNAVAILABLE', { force: true });
      }
      let items = this.items(partnerId + ':recent');
      for (var i = 0; i < items.length; i++) {
        let item = items[i];
        if (
          item.state &&
          ((item.tempId && item.tempId === tempId) || (item.id && res && item.id === res.id))
        ) {
          if (item.state === 'sending') {
            item.state = success ? 'sent' : 'error';
            if (err) {
              if (err == 'TICKET_UNAVAILABLE') {
                item.removed = [this.userId, partnerId];
                item.isRemoved = true;
              } else {
                item.text = this.getErrorMessage(err);
              }
            }
            if (success) {
              item.id = res.id;
              item.counter = res.counter;
              item.updated = Date.now();
              if (res.media && res.media.length > 0) {
                item.media = res.media.map((media, index) => {
                  return {
                    ...media,
                    uri: item.media[index].uri
                  };
                });
                item.files?.forEach((file) => {
                  let ext = file.name?.split('.').pop().toLowerCase();
                  if (file.name?.indexOf('.') === -1) {
                    ext = '';
                  }
                  this.warn('api update dicom', ext);
                  if (file.isAudioRecording) {
                    let mediaFile = item.media.find((mf) => file.name === mf.originalName);
                    if (mediaFile?.peaks) file.peaks = mediaFile.peaks;
                  } else if (!ext || ['zip', 'rar', '7z', 'dcm'].includes(ext)) {
                    let mediaFile = item.media.find((mf) => file.name === mf.originalName);
                    this.warn('api update dicom 2', file, mediaFile);
                    if (mediaFile?.isDicom) {
                      Object.keys(mediaFile).forEach((key) => {
                        if (key !== 'uri') file[key] = mediaFile[key];
                        if (file.file) file.file[key] = mediaFile[key];
                      });
                      this.warn('api update dicom done', file);
                    }
                  }
                });
                this.setStateSilent({
                  itemUpdated: Date.now()
                });
              }
            }
          } else {
            this.log('message found but already settled, ignoring by api');
          }
          break;
        }
      }
    });
  }
  hasMore = (id) => {
    const { total = 0 } = this.getCurrent(id);
    const items = this.items(id);
    return items.length < total;
  };
}

export default new Messages();
